import { Image as PdfImage } from '@react-pdf/renderer';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { ZillowHomeValueIndexTrends } from '../../marketConditions/zillow/ZillowHomeValueIndexTrends.tsx';
import { MarketConditionsAdjustmentExportTable } from '../Export/MarketConditionsAdjustmentExportTable.tsx';
import { SummaryTable } from '../SummaryTable.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { PNG_HEIGHT, PNG_WIDTH } from '../utils/constants.ts';

export const AdjustmentBreakdownMarketConditionsChart = ({
  ...props
}: Tkv2PairedCostSummaryInterfaceV2 & {
  marketTrendsPngSource?: string;
}) => {
  const { housingTrends, marketTrendsPngSource } = props;
  const isZillow = !!housingTrends?.filteredHousingTrendsData.isZillow;

  return (
    <>
      <WebOnly>
        {housingTrends?.filteredHousingTrendsData && (
          // The web version includes the chart as part of this component
          <ZillowHomeValueIndexTrends
            filteredHousingTrendsData={housingTrends.filteredHousingTrendsData}
            isZillow={housingTrends.filteredHousingTrendsData.isZillow}
            timestamp={housingTrends.filteredHousingTrendsData.effectiveDate.toEndOfDay()}
          />
        )}
      </WebOnly>
      <PDFOnly>
        <MarketConditionsAdjustmentExportTable {...props} />
        {marketTrendsPngSource && housingTrends?.filteredHousingTrendsData && (
          <SummaryTable>
            <Typography variant="h5">
              {isZillow
                ? `Zillow Typical Home Value (${props.housingTrends?.postalCode})`
                : `MLS Median Close Price (${props.housingTrends?.postalCode})`}
            </Typography>
            <PdfImage
              src={props.marketTrendsPngSource}
              style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
            />
            <Typography variant="h5">{`Effective Date: ${props.housingTrends?.filteredHousingTrendsData.effectiveDate.format(
              'MMM dd, yyyy',
            )}`}</Typography>
          </SummaryTable>
        )}
      </PDFOnly>
    </>
  );
};
